<template>
  <header class="relative z-40">
    <nav class="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
      <div class="flex lg:flex-1">
        <a href="#" class="-m-1.5 p-1.5">
          <span class="sr-only">PDFGen by Fourth Node</span>
          <div class="text-2xl font-bold text-white">PDFGen <span class="text-sm font-normal text-gray-300">by Fourth Node</span></div>
        </a>
      </div>
      <div class="flex lg:hidden">
        <button @click="toggleMobileMenu" type="button" class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-300">
          <span class="sr-only">Open main menu</span>
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
          </svg>
        </button>
      </div>
      <div class="hidden lg:flex lg:gap-x-12">
        <a @click="scrollToSection('features')" href="#features" class="text-sm font-semibold leading-6 text-gray-300 hover:text-white cursor-pointer">Features</a>
        <a @click="scrollToSection('about')" href="#about" class="text-sm font-semibold leading-6 text-gray-300 hover:text-white cursor-pointer">About</a>
      </div>
    </nav>
    <!-- Mobile menu -->
    <div v-show="mobileMenuOpen" class="lg:hidden" role="dialog" aria-modal="true">
      <div class="fixed inset-0 z-50"></div>
      <div class="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-black px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-800">
        <div class="flex items-center justify-between">
          <a href="#" class="-m-1.5 p-1.5">
            <span class="sr-only">PDFGen by Fourth Node</span>
            <div class="text-2xl font-bold text-white">PDFGen <span class="text-sm font-normal text-gray-300">by Fourth Node</span></div>
          </a>
          <button @click="toggleMobileMenu" type="button" class="-m-2.5 rounded-md p-2.5 text-gray-300">
            <span class="sr-only">Close menu</span>
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="mt-6 flow-root">
          <div class="-my-6 divide-y divide-gray-800">
            <div class="space-y-2 py-6">
              <a @click="scrollToSection('features'); toggleMobileMenu()" href="#features" class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-300 hover:bg-gray-900 hover:text-white cursor-pointer">Features</a>
              <a @click="scrollToSection('about'); toggleMobileMenu()" href="#about" class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-300 hover:bg-gray-900 hover:text-white cursor-pointer">About</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useAnalytics } from '../composables/useAnalytics'

const mobileMenuOpen = ref(false)
const analytics = useAnalytics()

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
  analytics.trackButtonClick('Mobile Menu Toggle', 'Header')
}

const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId)
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
    // Track section navigation
    analytics.trackPageView(`/#${sectionId}`, `PDFGen - ${sectionId.charAt(0).toUpperCase() + sectionId.slice(1)}`)
    analytics.trackButtonClick(`Nav - ${sectionId}`, 'Header')
  }
}
</script>
